import { Users, Package, Building2, Home, UserCog, Key, FileText, Shield, Database } from 'lucide-react';

export const menuSections = [
    {
        label: 'CLIENT MANAGEMENT',
        items: [
            { id: 'dashboard', label: 'Dashboard', icon: Home, path: '/dashboard', permission: 'DASHBOARD:READ' },
            { id: 'clients', label: 'Clients', icon: Users, path: '/clients', permission: 'CLIENTS:READ' },
        ],
    },
    {
        label: 'BUSINESS SETUP',
        items: [
            { id: 'companies', label: 'Companies', icon: Building2, path: '/companies', permission: 'COMPANIES:READ' },
            { id: 'products', label: 'Products', icon: Package, path: '/products', permission: 'PRODUCTS:READ' },
        ],
    },
    {
        label: 'COMPLIANCE',
        items: [
            {
                id: 'kyc', label: 'KYC', icon: Shield, permission: 'KYC:READ',
                children: [
                    { id: 'kyc-queue', label: 'KYC Queue', path: '/compliance/kyc/queue' },
                    { id: 'kyc-settings', label: 'KYC Settings', path: '/compliance/kyc/settings', permission: 'KYC_CONFIG:READ' },
                ],
            },
            {
                id: 'assets-parent', label: 'Assets', icon: Package, permission: 'ASSETS:READ',
                children: [
                    { id: 'asset-list', label: 'Asset List', path: '/compliance/assets' },
                    { id: 'asset-requirements', label: 'Asset Requirements', path: '/compliance/assets/requirements', permission: 'ASSET_CONFIG:READ' },
                ],
            },
        ],
    },
    {
        label: 'DATA GOVERNANCE',
        items: [
            {
                id: 'data-quality', label: 'Data Quality', icon: Database, permission: 'DATA_QUALITY:READ',
                children: [
                    { id: 'dq-dashboard', label: 'Dashboard', path: '/data-quality/dashboard' },
                    { id: 'dq-duplicates', label: 'Duplicates', path: '/data-quality/duplicates' },
                    { id: 'dq-completeness', label: 'Completeness', path: '/data-quality/completeness' },
                    { id: 'dq-issues', label: 'Issues', path: '/data-quality/issues' },
                    { id: 'dq-cleanup', label: 'Cleanup Tools', path: '/data-quality/cleanup', permission: 'DATA_QUALITY:WRITE' },
                    { id: 'dq-merge-history', label: 'Merge History', path: '/data-quality/merge/history', permission: 'DATA_QUALITY:MERGE' },
                    { id: 'dq-rules', label: 'Completeness Rules', path: '/data-quality/rules', permission: 'DATA_QUALITY:ADMIN' },
                ],
            },
        ],
    },
    {
        label: 'SYSTEM',
        items: [
            { id: 'system-users', label: 'Users', icon: UserCog, path: '/system/users', permission: 'USERS:READ' },
            { id: 'system-roles', label: 'Roles & Permissions', icon: Key, path: '/system/roles', permission: 'ROLES:READ' },
            { id: 'audit-logs', label: 'Audit Logs', icon: FileText, path: '/system/audit-logs', permission: 'AUDIT:READ' },
        ],
    },
];

export function visibleNav(can) {
    const allowed = (x) => !x.permission || can(x.permission);
    return menuSections
        .map((section) => ({
            ...section,
            items: section.items
                .filter(allowed)
                .map((item) => (item.children ? { ...item, children: item.children.filter(allowed) } : item))
                .filter((item) => !item.children || item.children.length > 0),
        }))
        .filter((section) => section.items.length > 0);
}
